export default "__VITE_ASSET__DRVGQeta__"